import { CONFIRM_DETAILS_FORM_FIELDS } from '../../constants'
import styles from '../ConfirmDetailsModal.module.scss'
import { UseFormReturn } from 'react-hook-form'
import { confirmDetailsSchema } from '../../schema'
import { z } from 'zod'
import { useGetConfirmDetails } from '../../api/useGetConfirmDetails'
import { Checkbox } from '@/components/Forms'
import { formatInTimeZone } from 'date-fns-tz'

export const ShiftTime = ({ form }: { form: UseFormReturn<z.infer<typeof confirmDetailsSchema>> }) => {
    const { data: confirmDetailsData } = useGetConfirmDetails()

    const dutyCode = form.watch(CONFIRM_DETAILS_FORM_FIELDS.dutyCode)
    const selectedDuty = confirmDetailsData?.duties.find((duty) => duty.dutyCode === dutyCode)
    const shiftTimeRange = selectedDuty
        ? `${formatInTimeZone(selectedDuty.from, 'Europe/London', 'HH:mm')} - ${formatInTimeZone(selectedDuty.to, 'Europe/London', 'HH:mm')}`
        : 'Shift time not found'

    return (
        <>
            {dutyCode ? (
                <div className={styles.shiftContainer}>
                    <span className={styles.shiftLabel}>Shift time</span>
                    <span className={styles.shift}>{shiftTimeRange}</span>
                </div>
            ) : (
                <Checkbox name={CONFIRM_DETAILS_FORM_FIELDS.noDuty} label="I don’t have a duty" />
            )}
        </>
    )
}
